import React, { useEffect, useRef } from "react"
import styled from "styled-components"
import { srConfig } from "@config"
import sr from "@utils/sr"
import { usePrefersReducedMotion } from "@hooks"

const StyledSection = styled.section`
  max-width: 900px;

  .inner {
    display: grid;
    gap: 40px;
  }

  .item {
    padding: 28px;
    border-radius: var(--border-radius);
    background-color: var(--light-navy);
    box-shadow: 0 10px 30px -15px var(--navy-shadow);
  }

  h3 {
    margin-bottom: 8px;
    color: var(--lightest-slate);
    font-size: var(--fz-xxl);
  }

  .eyebrow {
    margin-bottom: 12px;
    color: var(--green);
    font-family: var(--font-mono);
    font-size: var(--fz-xs);
  }

  .meta {
    margin-bottom: 18px;
    color: var(--light-slate);
    font-family: var(--font-mono);
    font-size: var(--fz-xs);
    line-height: 1.8;
  }

  p {
    margin-bottom: 0;
  }

  ul {
    ${({ theme }) => theme.mixins.fancyList};
    margin-top: 18px;
  }
`

const RecentLearning = () => {
  const revealContainer = useRef(null)
  const prefersReducedMotion = usePrefersReducedMotion()

  useEffect(() => {
    if (prefersReducedMotion) {
      return
    }

    sr.reveal(revealContainer.current, srConfig())
  }, [])

  return (
    <StyledSection id="recent-projects-learning" ref={revealContainer}>
      <h2 className="heading">Recent Projects and Learning</h2>

      <div className="inner">
        <article className="item">
          <p className="eyebrow">EDUCATION &amp; PROFESSIONAL DEVELOPMENT</p>
          <h3>Parsity - AI Accelerator Program - Remote</h3>
          <p className="meta">In progress (expected completion May 2026)</p>
          <p>
            Building RAG pipelines, vector databases, and multi-agent
            orchestration while deepening my understanding of LLM foundations,
            retrieval optimization, and deployment best practices.
          </p>
        </article>

        <article className="item">
          <p className="eyebrow">PROJECT HIGHLIGHT</p>
          <h3>Genomic Data Processing and Microblogging Web Application</h3>
          <p>
            Last year, I built a web application for genomic data processing and
            microblogging. You can find the project link below under{" "}
            <a href="/#projects">Recent Projects</a>.
          </p>

          <ul>
            <li>
              Built a Python ETL pipeline using Pandas and SQLAlchemy to model
              gene annotation data, user relationships, and ETL metadata, with
              schema migrations managed through Alembic.
            </li>
            <li>
              Developed a Flask web app and REST API for user profiles and
              microblogging, including Elasticsearch-powered full-text search
              for posts and Redis Queue for background notifications.
            </li>
            <li>
              Deployed a Dockerized microservice architecture with Flask, MySQL,
              Elasticsearch, and Redis to AWS ECS, with secrets managed through
              AWS Secrets Manager.
            </li>
            <li>
              Implemented end-to-end CI/CD with CodePipeline and CodeBuild, plus
              semantic versioning and immutable ECR tags.
            </li>
          </ul>
        </article>
      </div>
    </StyledSection>
  )
}

export default RecentLearning
